import './style.css';
import iconLupa from '../../assets/icons/icon-lupa.svg';


function NotFoundContainer(){
    return <div className="not-found-container">
        <img className="not-found-logo" src={iconLupa} alt=""/>
        <h3 className="not-found-title">No encontramos resultados</h3>
        <p className="not-found-content">Revisá que la palabra esté bien escrita. Probá utilizando términos más generales.</p>
    </div>
}

export default NotFoundContainer;